import { STATE_KEY } from './constants';

export const SET_SITES = `${STATE_KEY}/SET_SITES`;
export const SET_SITES_FULL = `${STATE_KEY}/SET_SITES_FULL`;
export const SET_SITES_SEARCH = `${STATE_KEY}/SET_SITES_SEARCH`;
export const CLEAR_SITES = `${STATE_KEY}/CLEAR_SITES`;
export const CLEAR_SITES_BY_ATTR = `${STATE_KEY}/CLEAR_SITES_BY_ATTR`;
export const NO_RESULTS = `${STATE_KEY}/NO_RESULTS`;
export const SET_SITES_BY_ATTR = `${STATE_KEY}/SET_SITES_BY_ATTR`;
